import React, { useId } from 'react'
import PropTypes from 'prop-types'

const LinkIcon = React.forwardRef(function LinkIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1241 4.8783C17.9428 3.70564 16.045 3.70923 14.8771 4.87711L9.87936 9.87484C9.87902 9.87519 9.87867 9.87554 9.87832 9.87589C8.70564 11.0572 8.70922 12.955 9.87711 14.1229C10.2676 14.5134 10.2676 15.1466 9.87711 15.5371C9.48658 15.9276 8.85342 15.9276 8.46289 15.5371C6.51113 13.5853 6.51436 10.4239 8.46064 8.46516L8.46289 8.46289L8.46289 8.46289L13.4629 3.46289C15.4147 1.51113 18.5761 1.51436 20.5348 3.46064L20.5371 3.46289C22.4889 5.41466 22.4856 8.57609 20.5394 10.5348C20.1501 10.9266 19.5169 10.9286 19.1252 10.5394C18.7334 10.1501 18.7314 9.51693 19.1206 9.12516C20.294 7.94431 20.2911 6.04663 19.1241 4.8783Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1229 8.46291C14.5134 8.07238 15.1466 8.07238 15.5371 8.46291C17.4889 10.4147 17.4856 13.5761 15.5394 15.5349L15.5371 15.5371L10.5371 20.5371C8.58534 22.4889 5.42391 22.4856 3.46516 20.5394L3.46289 20.5371C1.51113 18.5854 1.51436 15.4239 3.46064 13.4652C3.84991 13.0734 4.48307 13.0714 4.87484 13.4607C5.26661 13.8499 5.26864 14.4831 4.87936 14.8749C3.70601 16.0557 3.70887 17.9535 4.876 19.1218C6.05733 20.2944 7.95504 20.2908 9.12289 19.1229L14.1206 14.1252C14.121 14.1248 14.1213 14.1245 14.1217 14.1241C15.2944 12.9428 15.2908 11.045 14.1229 9.87712C13.7324 9.4866 13.7324 8.85343 14.1229 8.46291Z"
      ></path>
    </svg>
  )
})

LinkIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

LinkIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default LinkIcon
